module.exports = __webpack_public_path__ + "static/media/nicolas-dosselaere.1ebe694c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/avatars/nicolas-dosselaere.jpg
// module id = 825
// module chunks = 0